import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RampUnit = ({ type, id}) => {
    const location = useLocation();

    // Function to add ad units
    const addUnits = () => {
        window.ramp.que.push(() => {
            window.ramp.addUnits([{ type, selectorId: id }])
                .catch(e => console.warn('Error adding units:', e))
                .finally(() => window.ramp.displayUnits());
        });
    };

    // Cleanup function to remove ad units
    const cleanUp = () => {
        const slots = window.ramp?.settings?.slots;
        if (!slots) return;

        const slotToRemove = Object.entries(slots).find(([_, slot]) =>
            slot.element?.parentElement?.id === id
        )?.[0];

        if (slotToRemove) {
            window.ramp.destroyUnits([slotToRemove]);
        }
    };

    useEffect(() => {
        
        addUnits();

        return () => cleanUp();
    }, [type, id, location.pathname]);

    return <div id={id}></div>
};

export default RampUnit;